import { defineSlotRecipe } from "@pandacss/dev";

export const slots = [
  "title",
  "body",
  "description",
  "root",
  "icon",
  "actionTrigger",
] as const;

export const aromaToast = defineSlotRecipe({
  className: "aroma-toast",
  jsx: ["Toast"],
  slots,
  base: {
    root: {
      borderRadius: "l",
      display: "flex",
      gap: "gap.2",
      px: "padding.4",
      py: "padding.1",
      textStyle: "paragraph.m.regular",
      textAlign: "left",
      alignItems: "center",
      color: "content.neutral.reverse.bold",
      maxWidth: "width.m",
      shadow: "effect.shadow.bold-bottom",
      width: "width.s",
      opacity: "var(--opacity)",
      height: "var(--height)",
      overflowWrap: "anywhere",
      position: "relative",
      scale: "var(--scale)",
      translate: "var(--x) var(--y) 0",
      willChange: "translate, opacity, scale",
      zIndex: "var(--z-index)",
      transitionDuration: "slow",
      transitionProperty: "translate, scale, opacity, height",
      transitionTimingFunction: "default",
      minHeight: "2xl",
      flexWrap: "wrap",
      alignContent: "center",

      '&:has([data-part="action-trigger"])': {
        pr: "padding.1",
      },
    },
    icon: {
      alignSelf: "center",
      fontSize: "{sizes.xs}",
    },
    title: {
      textStyle: "title.s",
      gap: "gap.2",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
    },
    description: {
      textStyle: "paragraph.m.regular",
    },
    actionTrigger: {
      textStyle: "title.s",
      color: "content.neutral.reverse.subtle",
      cursor: "pointer",
      px: "padding.4",
      height: "xl",
    },
  },
  variants: {
    function: {
      neutral: {
        root: {
          backgroundColor: "background.neutral.base.bold",
        },
      },
      info: {
        root: {
          backgroundColor: "background.functional.info.bold",
        },
      },
      success: {
        root: {
          backgroundColor: "background.functional.success.bold",
        },
      },
      warning: {
        root: {
          backgroundColor: "background.functional.warning.bold",
        },
      },
      error: {
        root: {
          backgroundColor: "background.functional.error.bold",
        },
      },
      "ai-success": {
        root: {
          position: "relative",
          backgroundColor: "background.neutral.base.subtlest",
          borderWidth: "m",
          borderColor: "border.ai",
          color: "background.decorative.purple.base-bold",
          _aromaticonChildren: {
            bg: "background.ai.bold-hover",
            color: "transparent",
            backgroundClip: "text",
          },
          "& span": {
            bg: "background.ai.bold-hover",
            color: "transparent",
            backgroundClip: "text",
          },
          _before: {
            content: '""',
            position: "absolute",
            inset: "-1px",
            padding: "1px",
            borderRadius: "l",
            background: "{colors.border.ai-hover}",
            WebkitMask:
              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            WebkitMaskComposite: "xor",
            maskComposite: "exclude",
            pointerEvents: "none",
          },
        },
      },
    },
  },
  defaultVariants: { function: "neutral" },
});
